import React, { useState } from 'react';
import './CheckupStartPage.css';
import {useNavigate} from "react-router-dom"; // подключим стили отдельно

export const CheckupStartPage = () => {
    const [showModal, setShowModal] = useState(false);

    const handleStartClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const navigate = useNavigate();

    const handleAgree = () => {
        navigate('/questionnaire');
    };

    return (
        <main className="layout__content">
            <section className={`section layout__section test ${showModal ? 'blurred' : ''}`}>
                <div className="container">
                    <div className="section__content">
                        <div className="test__intro test-intro">
                            <div className="test-intro__bg test-intro-bg">
                                <div
                                    className="test-intro-bg__image"
                                    style={{ backgroundImage: `url('/img/test-intro-image1.jpg')` }}
                                ></div>
                                <div
                                    className="test-intro-bg__image"
                                    style={{ backgroundImage: `url('/img/test-intro-image2.jpg')` }}
                                ></div>
                            </div>

                            <div className="test-intro__block test-intro-block">
                                <div className="test-intro-block__inner">
                                    <header className="test-intro-block__header">
                                        <h1 className="title test-intro-block__title">Онлайн чекап</h1>
                                        <span className="test-intro-block__company">Bionmax 3.0</span>
                                    </header>
                                    <div className="test-intro-block__content">
                                        <p className="test-intro-block__description">
                                            Пройдите тест и получите персональные рекомендации по здоровому образу жизни
                                        </p>
                                        <div className="test-intro-block__images test-intro-block-images">
                                            <div className="test-intro-block-images__item">
                                                <div className="test-intro-block-images__image-wrapper">
                                                    <img className="test-intro-block-images__image"
                                                         src="/img/test-intro-image1.jpg"
                                                         alt=""/>
                                                </div>
                                            </div>
                                            <div className="test-intro-block-images__item">
                                                <div className="test-intro-block-images__image-wrapper">
                                                    <img className="test-intro-block-images__image"
                                                         src="/img/test-intro-image2.jpg"
                                                         alt=""/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="test-intro-block__action">
                                            <button className="button button_outline" onClick={handleStartClick}>
                                                Пройти тест
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {showModal && (
                <div className="modal">
                    <div className="modal__content">
                        <button className="modal__close" onClick={handleCloseModal}>×</button>
                        <h2><strong>! ВАЖНОЕ ПРЕДУПРЕЖДЕНИЕ</strong></h2>
                        <p>
                            <span style={{ color: '#b02095', fontWeight: 600 }}>
                                Этот тест не является медицинской диагностикой.
                            </span>{' '}
                            Если у вас есть <strong>хронические заболевания</strong>, подтверждённые диагнозы или{' '}
                            <strong>вы находитесь под наблюдением врача</strong>, пожалуйста, <strong>не проходите тест</strong>{' '}
                            и не используйте рекомендации сервиса без консультации со специалистом.
                        </p>
                        <button className="modal__submit" onClick={handleAgree}>
                            Пройти тест
                        </button>
                    </div>
                </div>
            )}
        </main>
    );
};
